import React from "react";
import MediaQuery from "react-responsive";
import styled from "styled-components";
//
import Address from "containers/address";
import Navigation from "containers/navigation";
import Logo from "containers/logo";
//
export default ({ on }) => (
  <Wrap active={on}>
    <Logo />
    <MediaQuery maxWidth={768}>
      <Address />
    </MediaQuery>
    <Navigation />
  </Wrap>
);
//
const Wrap = styled.div`
  display: ${({ active }) => (active ? "grid" : "none")};
  grid-template-areas: "logo address" "navigation navigation";
  grid-template-columns: 1fr 1fr;

  @media (min-width: 768px) {
    display: block;
  }
`;
